import React from 'react'
import Alert from './Alert'

interface AlertMessageProps {
  type?: 'info' | 'success' | 'warning' | 'error'
  message: string
  className?: string
}

const AlertMessage = ({type, message, className = ''}: AlertMessageProps) => {
  return (
    <Alert type={type} className={className}>
      <p>{message}</p>
    </Alert>
  )
}

export default AlertMessage
